import { Button, FormControl, Grid } from "@mui/material";
import GKModal from "components/GKModal";
import GKSelect from "components/GKSelect";
import { Controller, useForm } from "react-hook-form";

const EditPlan = ({ open, setOpen }) => {
  const { control } = useForm({
    defaultValues: {
      plantype: "",
    },
  });

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Edit Plan"
      footer={
        <Grid container justifyContent="flex-end">
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
              mr: 2,
            }}
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
              mr: 2,
            }}
            type="submit"
            form="create-broker-form"
            variant="outlined"
          >
            {"Submit"}
          </Button>
        </Grid>
      }
    >
      <br />
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <FormControl variant="standard" fullWidth>
            <Controller
              name="plantype"
              control={control}
              render={({ field }) => (
                <GKSelect {...field} inputLabel="Select Plan Type" />
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
    </GKModal>
  );
};

export default EditPlan;
